/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const StatusResponse = zod.object({
  systemOfRecord: zod.enum(['onearly-core']),
  version: zod.string(),
});

export type StatusResponse = zod.input<typeof StatusResponse>;
export type StatusResponseOutput = zod.output<typeof StatusResponse>;
